import { Mail, Phone, MapPin, Instagram, Facebook, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-text-main text-white pt-24 pb-12 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          <div className="space-y-8">
            <Link to="/" className="inline-block">
              <img src="/logo.png" alt="Novità" className="h-12 w-auto" />
            </Link>
            <p className="text-text-muted text-sm leading-relaxed font-medium">
              Excelência em telemedicina e cuidado humanizado. Transformando a saúde através da tecnologia e do compromisso com a vida.
            </p>
            <div className="flex space-x-5">
              {[
                { icon: Facebook, label: 'Facebook' },
                { icon: Instagram, label: 'Instagram' },
                { icon: Linkedin, label: 'Linkedin' }
              ].map((social) => (
                <a key={social.label} href="#" className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center hover:bg-primary hover:text-white transition-all border border-white/10">
                  <span className="sr-only">{social.label}</span>
                  <social.icon className="w-5 h-5 opacity-70" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-black mb-8 uppercase tracking-widest text-primary font-display">Links Rápidos</h3>
            <ul className="space-y-4">
              {['Início', 'Planos', 'Cadastrar', 'Login'].map((item) => (
                <li key={item}>
                  <Link to={item === 'Início' ? '/' : `/${item.toLowerCase()}`} className="text-text-muted hover:text-white transition-colors font-medium flex items-center group">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-black mb-8 uppercase tracking-widest text-primary font-display">Contato</h3>
            <ul className="space-y-6">
              <li className="flex items-start space-x-4">
                <div className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center shrink-0 border border-white/10">
                  <Phone className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <div className="text-xs font-black text-text-muted uppercase mb-1">Telefone</div>
                  <a href="tel:+556130413218" className="text-bg-light hover:text-primary transition-colors font-bold">(61) 3041-3218</a>
                </div>
              </li>
              <li className="flex items-start space-x-4">
                <div className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center shrink-0 border border-white/10">
                  <Mail className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <div className="text-xs font-black text-text-muted uppercase mb-1">E-mail</div>
                  <a href="mailto:contato@novitahomecare.com.br" className="text-bg-light hover:text-primary transition-colors font-bold">contato@novitahomecare.com.br</a>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-black mb-8 uppercase tracking-widest text-primary font-display">Localização</h3>
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center shrink-0 border border-white/10">
                <MapPin className="h-5 w-5 text-primary" />
              </div>
              <div>
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=SRTVN,+Conjunto+P,+Ed.+Brasília+Rádio+Center,+Sala+SS-06,+Brasília/DF+-+CEP:+70719-900" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-bg-light font-bold leading-relaxed hover:text-primary transition-colors block"
                >
                  Brasília - DF<br />
                  <span className="text-text-muted font-medium text-sm">SRTVN, Conjunto P, Ed. Brasília Rádio Center, Sala SS-06, Brasília/DF - CEP: 70719-900</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-text-muted text-xs font-bold uppercase tracking-widest">
            &copy; 2026 Novità Health Group. Todos os direitos reservados.
          </p>
          <div className="flex space-x-8 text-xs font-bold text-text-muted uppercase tracking-widest">
            <a href="#" className="hover:text-primary transition-colors">Privacidade</a>
            <a href="#" className="hover:text-primary transition-colors">Termos</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
